module.exports = __webpack_public_path__ + "static/media/sudoku.9212ac07.jpg";